import React from 'react';

interface Props {
  className?: string;
  strokeWidth?: number;
}

/**
 * TikTok icon - Lucide doesn't ship one, so this is a minimal SVG.
 * Styled to match Lucide's stroke-based line-art language.
 */
const TikTokIcon: React.FC<Props> = ({ className = '', strokeWidth = 2 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

export default TikTokIcon;
